import Response from "../../Data/Domain/Response";
import Events from "../Domain/Events";
import { getEventsByUser, createEvent } from "./Events.service";

export async function getEventsByUserRepository(id) {
  const data = await getEventsByUser(id);
  const { resources, count } = new Response(data, Events).getMultiple();
  return { resources, count };
}

export async function createEventRepository(eventData) {
  const data = await createEvent(eventData);
  return new Response(data, Events).getSingle();
}